import React from 'react';
import './ActiveInstructors.css';

const ActiveInstructors = () => {
  return (
    <div className="active-instructors-card">
      <div className="card-header">
        
      </div>
      <div className="card-content">
        {/* Placeholder for active instructors list */}
      </div>
    </div>
  );
};

export default ActiveInstructors;
